'use strict';
// @flow

import 'babel-polyfill';
import React from 'react';
import _ from 'lodash';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import BackButton from 'components/renter_application/BackButtonComponent';
import InputComponent from 'components/shared/InputComponent';
import SelectComponent from 'components/shared/SelectComponent';
import ScreeningParamsActions from 'actions/ScreeningParamsActions';
import ScreeningParamsStore from 'stores/ScreeningParamsStore';
import * as Validations from 'validations/HomieValidations';
import styled from 'styled-components';
import { SCREENING_PARAMS } from 'utils/Constants';
import $_ from 'jquery';

const HomeApplicaationReferenceForm = styled.div`
  padding-bottom: 20px;
`;

const StyledForm = styled.form`
  margin-top: ${props => (props.addMargin ? 70 : 0)}px;
`;

const PlaceTypeInput = styled.span`
  position: absolute;
  top: 0;
  right: 18px;
  height: 35px;
  color: #9b9b9b;
  font-size: 14px;
  line-height: 35px;
  z-index: 2;
`;

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  onCancel: () => void,
  onPrevStep: () => void,
  isForAdvisor?: boolean
};

type ReferenceType = {
  name: string,
  last_name: string,
  second_last_name: string,
  email: string,
  relationship: string,
  mobile_phone: string,
  address: {
    street: string,
    ext_number: string,
    int_number: string,
    neighborhood: string,
    town: string,
    state: string,
    country: string,
    zip: string
  }
};

type StateType = {
  relationship: Array<any>,
  references: Array<ReferenceType>,
  referenceWeb: string,
  twitterLink: string,
  linkedinLink: string,
  facebookLink: string,
  generalError: boolean
};

export default class ReferencesContent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    isForAdvisor: false
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      relationship: [],
      references: this.defaultValues(),
      referenceWeb: '',
      twitterLink: '',
      linkedinLink: '',
      facebookLink: '',
      generalError: false
    };
  }

  defaultValues = (): Array<ReferenceType> => {
    const propsReferences = this.props.homeApplication.references;
    const number_of_references = this.props.homeApplication
      .number_of_references;
    const references = [];

    for (let i = 0; i < number_of_references; i++) {
      const reference = propsReferences[i] || {};
      references.push(this._buildReferenceObject(reference));
    }

    return references;
  };

  _buildReferenceObject = (data: any): ReferenceType => {
    return {
      name: _.get(data, 'name') || '',
      last_name: _.get(data, 'last_name') || '',
      second_last_name: _.get(data, 'second_last_name') || '',
      email: _.get(data, 'email') || '',
      mobile_phone: _.get(data, 'mobile_phone') || '',
      relationship: _.get(data, 'relationship') || '',
      address: {
        street: _.get(data, 'address.street') || '',
        ext_number: _.get(data, 'address.ext_number') || '',
        int_number: _.get(data, 'address.int_number') || '',
        neighborhood: _.get(data, 'address.neighborhood') || '',
        town: _.get(data, 'address.town') || '',
        state: _.get(data, 'address.state') || '',
        country: _.get(data, 'address.country') || '',
        zip: _.get(data, 'address.zip') || ''
      }
    };
  };

  componentDidMount = (): void => {
    ScreeningParamsActions.getScreeningParams({
      name: SCREENING_PARAMS.Relationship_physical
    });
  };

  componentWillMount = (): void => {
    ScreeningParamsStore.addChangeListener(this.onScreeningParamsChange);
  };

  componentWillUnmount = (): void => {
    ScreeningParamsStore.removeChangeListener(this.onScreeningParamsChange);
  };

  onScreeningParamsChange = (): void => {
    let relationship = [];
    const relation = ScreeningParamsStore.getScreeningParam(
      SCREENING_PARAMS.Relationship_physical
    );
    if (typeof relation !== 'undefined')
      relation.map(item =>
        relationship.push({ value: item.slug, label: item.name })
      );
    this.setState({ relationship });
  };

  submitSuccess = (values: {}): void => {
    this.props.onChange(values);
  };

  onValidChange = (
    value: string,
    path: string,
    callback?: () => void,
    index: number
  ): void => {
    this.setState(prevState => {
      prevState.references[index] = _.set(
        prevState.references[index],
        path,
        value
      );
      return prevState;
    }, callback);
  };

  handleSubmit = async (event: any): Promise<any> => {
    event.preventDefault();
    const references = this.state.references;
    this.executeValidations();
    let response = await this.isFieldsValidated();
    if (response) {
      const submitValue = {
        step: 'references',
        serialized_references: references.map(reference => {
          return this._buildReferenceObject(reference);
        })
      };
      this.submitSuccess(submitValue);
    } else {
      let error = true;
      this.setState(
        {
          generalError: error
        },
        () => {
          $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
        }
      );
    }
  };

  executeValidations = (): void => {
    document.querySelectorAll('form input').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  isFieldsValidated = async (): boolean => {
    let rerrors = await this.resolveAfter();
    return rerrors === 0;
  };

  resolveAfter = async (): Promise<any> => {
    return new Promise(resolve => {
      setTimeout(() => {
        const lengthError = document.querySelectorAll('form .error-message')
          .length;
        resolve(lengthError);
      }, 250);
    });
  };

  renderReferenceForm = (reference: any, index: number) => {
    const { relationship } = this.state;

    const { isForAdvisor } = this.props;

    const onValueChange = (_v: string, _p: string, _c?: () => void) => {
      this.onValidChange(_v, _p, _c, index);
    };

    return (
      <HomeApplicaationReferenceForm>
        <RenterApp.Title>Datos de la persona</RenterApp.Title>
        <SelectComponent
          name="relationship"
          placeholder="Relación"
          minSize={4}
          options={relationship}
          value={reference.relationship}
          isSearchable={false}
          onValueChange={onValueChange}
          schema={Validations.RequiredFieldSchema}
        />
        <InputComponent
          name="last_name"
          value={reference.last_name}
          type="text"
          placeholder="Primer apellido"
          onValueChange={onValueChange}
          schema={Validations.RequiredNameSchema}
        />
        <InputComponent
          name="second_last_name"
          value={reference.second_last_name}
          type="text"
          placeholder="Segundo apellido"
          onValueChange={onValueChange}
          schema={Validations.NameSchema}
        />
        <InputComponent
          name="name"
          value={reference.name}
          type="text"
          placeholder="Nombre (s)"
          onValueChange={onValueChange}
          schema={Validations.RequiredNameSchema}
        />
        {isForAdvisor && (
          <InputComponent
            name="relationship"
            value={reference.relationship}
            type="text"
            placeholder="Parentesco"
            onValueChange={onValueChange}
            schema={Validations.RequiredFieldSchema}
          />
        )}

        <InputComponent
          name="email"
          value={reference.email}
          type="email"
          placeholder="Correo"
          onValueChange={onValueChange}
          schema={Validations.RequiredEmailSchema}
        />
        <InputComponent
          name="mobile_phone"
          value={reference.mobile_phone}
          type="text"
          placeholder="Teléfono"
          onValueChange={onValueChange}
          schema={Validations.PhoneNumberWithCountryCodeSchema}
          maxLength={24}
        />

        {isForAdvisor && (
          <RenterApp.StyledValidatedInput>
            <InputComponent
              name="time_to_meet_him"
              min="0"
              value={reference.time_to_meet_him}
              type="number"
              onValueChange={onValueChange}
            />
            <PlaceTypeInput>años</PlaceTypeInput>
          </RenterApp.StyledValidatedInput>
        )}
      </HomeApplicaationReferenceForm>
    );
  };

  renderGuarantor = (reference: {}) => {
    return (
      <div>
        <RenterApp.Title>Fiador</RenterApp.Title>
        <InputComponent
          name="last_name"
          value={reference}
          type="text"
          placeholder="Primer apellido"
          onValueChange={() => {}}
          schema={Validations.RequiredNameSchema}
        />
        <InputComponent
          name="second_last_name"
          value={reference}
          type="text"
          placeholder="Segundo apellido"
          onValueChange={() => {}}
          schema={Validations.RequiredNameSchema}
        />
        <InputComponent
          name="name"
          value={reference}
          type="text"
          placeholder="Nombre (s)"
          onValueChange={() => {}}
          schema={Validations.RequiredNameSchema}
        />

        <InputComponent
          name="relationship"
          value={reference}
          type="text"
          placeholder="Parentesco"
          onValueChange={() => {}}
          schema={Validations.RequiredFieldSchema}
        />

        <InputComponent
          name="email"
          value={reference}
          type="email"
          placeholder="Correo"
          onValueChange={() => {}}
          schema={Validations.RequiredEmailSchema}
        />
        <InputComponent
          name="mobile_phone"
          value={reference}
          type="text"
          placeholder="Teléfono"
          onValueChange={() => {}}
          schema={Validations.PhoneNumberWithCountryCodeSchema}
          maxLength={24}
        />
      </div>
    );
  };

  render() {
    const { references } = this.state;
    const { isForAdvisor } = this.props;

    const renderedReferences = references.map((reference, index) => {
      return (
        <div key={index}>
          {references.length > 1 && <h3>Referencia {index + 1}</h3>}
          {this.renderReferenceForm(reference, index)}
        </div>
      );
    });
    return (
      <RenterApp.AppTabContainer>
        <RenterApp.BackButtonContainer
          onClick={this.props.onPrevStep}
          addMargin={isForAdvisor}
        >
          <BackButton text={'Ingresos'} />
        </RenterApp.BackButtonContainer>
        <RenterApp.AppTabForm>
          <StyledForm onSubmit={this.handleSubmit} addMargin={isForAdvisor}>
            {renderedReferences}
            {isForAdvisor && this.renderGuarantor()}
            <RenterApp.SubmitButton type="submit">
              Siguiente
            </RenterApp.SubmitButton>
          </StyledForm>
        </RenterApp.AppTabForm>
        {!isForAdvisor && (
          <RenterApp.CancelAppButton onClick={this.props.onCancel}>
            Cancelar aplicación
          </RenterApp.CancelAppButton>
        )}
      </RenterApp.AppTabContainer>
    );
  }
}
